import { useState, useRef, useEffect } from 'react';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20collage%20of%20fashion%20items%20sneakers%20hoodies%20accessories%20and%20bags%20arranged%20in%20a%20harmonious%20composition%20on%20warm%20cream%20and%20beige%20textured%20background%20with%20subtle%20olive%20and%20terracotta%20accents%20editorial%20aesthetic&width=1600&height=900&seq=hero-v2-bg-001&orientation=landscape"
          alt="CSSBuySpreadsheet produtos"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/18 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 py-32 md:py-40">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12 lg:gap-0">
          <div className="flex-1 w-full max-w-2xl">
            <div className="relative mb-8" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="inline-flex items-center gap-3 px-6 py-3.5 rounded-full bg-foreground-900/85 backdrop-blur-sm text-background-50 text-sm font-semibold hover:bg-foreground-800/90 transition-all duration-200 whitespace-nowrap"
              >
                <i className="ri-grid-line text-lg"></i>
                Explorar Categorias
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {dropdownOpen && (
                <div className="absolute top-full mt-2 left-0 w-72 bg-foreground-900/95 backdrop-blur-md rounded-2xl py-2 overflow-hidden z-50 max-h-80 overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.id}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      onClick={() => setDropdownOpen(false)}
                      className="flex items-center gap-3 px-5 py-3 text-sm text-background-50/90 hover:bg-background-50/10 hover:text-background-50 transition-colors duration-150"
                    >
                      <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center">
                        <i className="ri-shopping-bag-line text-background-50/70 text-sm"></i>
                      </span>
                      <div className="min-w-0">
                        <span className="font-medium">{cat.namePt}</span>
                        <span className="text-background-50/35 text-xs ml-1.5">({cat.name})</span>
                      </div>
                    </a>
                  ))}
                </div>
              )}
            </div>

            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
              CSSBuySpreadsheet 2026
            </h2>
            <h3 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-background-50/90 leading-tight mb-6">
              O Guia Mais Completo de Spreadsheets CSSBuy
            </h3>
            <p className="text-base md:text-lg text-background-50/80 max-w-lg mb-10 leading-relaxed">
              Descubra os melhores <strong className="text-background-50">CSSBuy spreadsheets</strong> com produtos atualizados, preços baixos e links diretos para compra segura na China. Atualizado diariamente.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-background-50 font-bold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap group"
              >
                CSSBuy Sheet
                <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border-2 border-background-50/50 text-background-50 font-bold text-base hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap group"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </a>
            </div>
          </div>

          <div className="hidden lg:flex flex-1 items-center justify-center">
            <div className="relative w-80 h-80 md:w-96 md:h-96">
              <div className="absolute inset-0 rounded-3xl bg-background-50/10 backdrop-blur-sm border border-background-50/15"></div>
              <div className="absolute top-6 left-6 right-6 bottom-6 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20product%20photography%20of%20stylish%20fashion%20items%20including%20sneakers%20a%20watch%20and%20a%20leather%20wallet%20arranged%20beautifully%20on%20a%20warm%20cream%20marble%20surface%20soft%20natural%20lighting%20luxury%20composition&width=800&height=800&seq=hero-v2-featured-002&orientation=squarish"
                  alt="CSSBuySpreadsheet produtos em destaque"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}